import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { UserContentReviewModerateFormMainSection } from './UserContentReviewModerateFormMainSection';

export type IUserContentReviewModerateFormValues = {
  reason?: string;
};

export type IUserContentReviewModerateFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IUserContentReviewModerateFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<IUserContentReviewModerateFormValues>;
    onSubmit?: SubmitHandler<IUserContentReviewModerateFormValues>;
  };

export const UserContentReviewModerateForm: React.FC<
  IUserContentReviewModerateFormProps
> = (props) => {
  const { defaultValues, ...other } = props;

  const form = useForm<IUserContentReviewModerateFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <UserContentReviewModerateFormMainSection form={form} />
    </ContentBlock.FormBody>
  );
};
